export enum StatusCodes {
    Conflict = 409,
    NotFound = 404,
    OK = 200,
    InternalServerError = 500
}




// WEBPACK FOOTER //
// ./src/app/customerservice/enums/status-code.enum.ts